// extracted by mini-css-extract-plugin
export default {"bg":"home_styles_bg__YeE04","wrapper":"home_styles_wrapper__2cH7b"};